<script>
import Layout from "@/components/pages/layouts/vertical";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters, mapState } from 'vuex';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      sortKey: '',
      sortOrders: {
        propertyName: 1,
        category: 1,
        sub_category: 1
      },
      selectedItemId: null
    }
  },
  computed: {
    ...mapGetters('item', ['inventoryItemsByCategory', 'inventoryItems']),
    ...mapState("navigation", ["breadcrumbItems"]),
    items() {
      const itemCategory = this.$route.params.category;
      let items = [];

      if (itemCategory) {
        items = this.inventoryItemsByCategory;
      } else if (this.inventoryItems)  {
        items = Object.values(this.inventoryItems).flat();
      }

      const sortKey = this.sortKey;
      const order = this.sortOrders[sortKey] || 1;

      items = items.slice().sort(function (a, b) {
        a = a[sortKey];
        b = b[sortKey];
        return (a === b ? 0 : a > b ? 1 : -1) * order;
      });

      return items;
    },
  },
  methods: {
    ...mapActions("item", { deleteItem: "deleteItem" }),
    sortBy(key) {

      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    categoryItemPath(categoryItem) {
      return `/properties/${categoryItem.property_id}/areas/${categoryItem.area_id}/items/${categoryItem.id}`;
    },
    selectItem(id, propertyId, areaId){
      this.selectedItemId = { id: id, propertyId: propertyId, areaId: areaId };
    },
    itemDelete(){
      const args = { id: this.selectedItemId.id, propertyId: this.selectedItemId.propertyId, areaId: this.selectedItemId.areaId };
      this.deleteItem(args);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader />
    <div v-if="this.items" class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Photo</th>
                    <th>Name</th>
                     <th>
                      <button class="sortbtn" @click="sortBy('propertyName')">
                        Property
                        <b-icon :icon="sortKey === 'propertyName' && sortOrders.propertyName === 1 ? 'sort-alpha-down' : 'sort-alpha-up'"></b-icon>
                      </button>
                    </th>
                    <th>
                      <button class="sortbtn" @click="sortBy('category')">
                        Category
                        <b-icon :icon="sortKey === 'category' && sortOrders.category === 1 ? 'sort-alpha-down' : 'sort-alpha-up'"></b-icon>
                      </button>
                    </th>
                    <th>
                      <button class="sortbtn" @click="sortBy('sub_category')">
                        Sub Category
                        <b-icon :icon="sortKey === 'sub_category' && sortOrders.sub_category === 1 ? 'sort-alpha-down' : 'sort-alpha-up'"></b-icon>
                      </button>
                    </th>
                    <th>Description</th>
                    <th style="min-width: 120px">Purchase Year</th>
                    <th v-if="$can('destroy', 'Item')">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(categoryItem, index) in this.items" :key="index">
                    <td><img v-if="categoryItem.photos.length" :src="categoryItem.photos[0].image_url" style="width: 67px;height: 100px;" /></td>
                    <td>
                      <router-link :to="categoryItemPath(categoryItem)">{{ categoryItem.name }}</router-link>
                    </td>
                    <td>
                      <router-link :to="`/properties/${categoryItem.property_id}`">{{ categoryItem.propertyName }}</router-link>
                    </td>
                    <td>{{ categoryItem.category }}</td>
                    <td>{{ categoryItem.sub_category }}</td>
                    <td>{{ categoryItem.description }}</td>
                    <td style="text-align: center;">{{ categoryItem.year_purchased }}</td>
                    <td class="text-center" v-if="$can('destroy', 'Item')">
                      <b-button v-b-modal.modal-deleteItem variant="danger" @click="selectItem(categoryItem.id, categoryItem.property_id, categoryItem.area_id)">
                        <i class="mdi mdi-cancel"></i>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-modal id="modal-deleteItem" title="Delete Item" @ok="this.itemDelete">
              Are you sure?
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .sortbtn {
    background: none;
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
  }
</style>
